import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import BoatsSection from "../components/sections/BoatsSection";
import ExperienceSection from "../components/sections/ExperienceSection";
import LocationSection from "../components/sections/LocationSection";
import ContactSection from "../components/sections/ContactSection";
import ReviewsSection from "../components/sections/ReviewsSection";
import PromiseSection from "../components/sections/PromiseSection";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#FAFAF8] text-[#1C1C1A] min-h-screen">
      <Header />
      <main>
        <Hero />
        <BoatsSection />
        <ExperienceSection />
        <PromiseSection />
        <ReviewsSection />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
